<template>
  <div>
    <button
      @click="showCreate = !showCreate"
      class="btn btn-sm btn-success mr-2"
    >
      <span class="ti-plus"></span> {{ showCreate ? "Отмена" : "Добавить" }}
    </button>
    <push-item
      v-if="showCreate"
      @close="showCreate = false"
      @push="push"
      :fields="fields"
      :setLink="`${cardPushLink}?id=${this.id}`"
    />
    <ul v-else-if="items.length && !showCreate" class="list-item">
      <li v-for="(item, key) in items" :key="key">
        <h5>#{{ item.id }}</h5>
        <fields-list :fields="fields" :item="item" />
        <div class="buttons">
          <button @click="postItem(item)" class="btn btn-sm btn-success mr-2">
            <span class="ti-save"></span> Сохранить
          </button>
          <button @click="removeItem(item)" class="btn btn-sm btn-danger">
            <span class="ti-trash"></span>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";
import PushItem from "../../Modals/PushItem.vue";
import FieldsList from "../FieldsList";
export default {
  components: {
    FieldsList,
    PushItem,
  },
  data: () => ({
    cardLink: "banners/slide",
    cardSetLink: "banners/update",
    cardPushLink: "banners/push",
    cardRejectLink: "banners/reject",
    showCreate: false,
    items: [],
    fields: [
      {
        col: "col-12 ",
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        col: "col-12 col-md-6",
        key: "is_active",
        label: "Активен",
        type: "checkbox",
        textType: "text",
      },
      {
        col: "col-12 ",
        key: "url",
        label: "Ссылка перехода",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12 col-md-6",
        key: "image",
        label: "ПК слайд",
        type: "img",
        textType: "text",
        isMultiLang: true,
      },
      {
        col: "col-12 col-md-6",
        key: "m_image",
        label: "Мобильный слдайд",
        type: "img",
        textType: "text",
        isMultiLang: true,
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.items = await this.cardContent(this.cardLink, this.id, "list");
  },
  methods: {
    cardContent: cardContent,
    cardUpdate: cardUpdate,
    push(val) {
      this.items.push(val);
    },
    postItem(item) {
      this.cardUpdate(
        `${this.cardPushLink}?id=${this.id}`,
        { push: item },
        `post`
      );
    },
    removeItem(item) {
      if (
        this.cardUpdate(
          `${this.cardRejectLink}?id=${this.id}`,
          { reject: item },
          `delete`
        )
      ) {
        for (let i = 0; i < this.items.length; i++) {
          if (item.id === this.items[i].id) {
            this.items.splice(i, 1);
            break;
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
.list-item {
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  & > li {
    border-bottom: 1px solid #ebebeb;
    padding: 20px 0;
    &:last-child {
      border-bottom: none;
    }
    & > .buttons {
      margin: 10px 0;
    }
  }
}
</style>
